module.exports = __webpack_public_path__ + "img/drsj.534f308b.svg";